// TODO - Documentar
// Scenarios Hook

import { useSelector } from 'react-redux'

import * as con from "../../GlobalConstants"

export const ScenariosHook = () =>
{
    const sce = useSelector((state) => state[con.REDUCER_SCENARIOS].byId)
    return(sce)
}


export const StateSingleScenario = (scenarioId) =>
{
    const sce = useSelector((state) => state[con.REDUCER_SCENARIOS].byId[scenarioId])

    return(sce)
}

export const SelectedScenarioHook = () => {
  const selectedScenario = useSelector((state) => {
    const scenarios = state[con.REDUCER_SCENARIOS].byId;
    const selectedId =
      state[con.REDUCER_APPLICATION_PARAMETERS][con.SELECTED_SCENARIO];

    return scenarios?.[selectedId];
  });

  return selectedScenario;
};

export const AllScenarioIds = () => {
  return (useSelector(
    state => Object.keys(state[con.REDUCER_SCENARIOS].byId)
  ));
}